<template>
  <button class="btn" @click.prevent="$emit('handleClick')">
    <v-icon v-if="iconClass" :clsName="iconClass" />
    <template v-if="!textHide">
      {{ text }}
    </template>
    <template v-else>
      <span class="access_hidden">{{ text }}</span>
    </template>
  </button>
</template>

<script>
import VIcon from '@/components/atoms/VIcon';

export default {
  components: {
    VIcon,
  },
  props: {
    btnStyle: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: 'BUTTON',
    },
    textHide: {
      type: Boolean,
      default: false,
    },
    iconClass: {
      type: String,
      default: '',
    },
  },
};
</script>
